import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const col1 = categories.slice(0, 7);
  const col2 = categories.slice(7);

  return (
    <footer className="relative w-full bg-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div>
            <h4 className="font-label text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4">
              Kategorie Odzieżowe
            </h4>
            <div className="w-8 h-px bg-background-400 mb-4"></div>
            <div className="flex flex-col gap-2">
              {col1.map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="font-body text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4">
              Kategorie Akcesoria
            </h4>
            <div className="w-8 h-px bg-background-400 mb-4"></div>
            <div className="flex flex-col gap-2">
              {col2.map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="font-body text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4">
              Poradniki SEO
            </h4>
            <div className="w-8 h-px bg-background-400 mb-4"></div>
            <div className="flex flex-col gap-2">
              <Link to="/artykul/kakobuy-spreadsheet-poradnik" className="font-body text-sm text-foreground-600 hover:text-foreground-950 transition-colors">
                Kakobuy Spreadsheet Poradnik
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="font-body text-sm text-foreground-600 hover:text-foreground-950 transition-colors">
                Kakobuy Spreadsheet
              </a>
              <span className="font-body text-sm text-foreground-600">
                Kakobuy Finds
              </span>
              <span className="font-body text-sm text-foreground-600">
                Poradnik bezpieczeństwa
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-label text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4">
              Nawigacja
            </h4>
            <div className="w-8 h-px bg-background-400 mb-4"></div>
            <div className="flex flex-col gap-2">
              <Link to="/" className="font-body text-sm text-foreground-600 hover:text-foreground-950 transition-colors">
                Strona główna
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="font-body text-sm text-foreground-600 hover:text-foreground-950 transition-colors">
                Buy It Now
              </a>
              <span className="font-body text-sm text-foreground-600">Kontakt</span>
              <span className="font-body text-sm text-foreground-600">Polityka prywatności</span>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-background-300/60 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-none">
              Kakobuy Finds
              <br />
              <span className="text-accent-600">Polska</span>
            </h3>
            <p className="font-body text-xs text-foreground-500 mt-2">
              Największa niezależna baza wiedzy o spreadsheetach
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-background-300 flex items-center justify-center text-foreground-600 hover:text-foreground-950 hover:bg-background-400 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-300 flex items-center justify-center text-foreground-600 hover:text-foreground-950 hover:bg-background-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-300 flex items-center justify-center text-foreground-600 hover:text-foreground-950 hover:bg-background-400 transition-colors cursor-pointer">
                <i className="ri-pinterest-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-300 flex items-center justify-center text-foreground-600 hover:text-foreground-950 hover:bg-background-400 transition-colors cursor-pointer">
                <i className="ri-telegram-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-300 flex items-center justify-center text-foreground-600 hover:text-foreground-950 hover:bg-background-400 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
            <span className="font-body text-xs text-foreground-400">
              &copy; 2026 Kakobuy Finds Polska. Wszelkie prawa zastrzeżone.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}